import React from "react";
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

const Owner = ({owner}) => {
    let textMessage = '';

    if (owner) {
        textMessage = <FormattedMessage id="thread.assigned" values={{owner: owner.name}}/>;
    } else {
        textMessage = <FormattedMessage id="thread.unassigned"/>;
    }

    return (
        <div className='media-body'>
            <p>{textMessage}</p>
        </div>
    );
};

Owner.propTypes = {
    owner: PropTypes.any
};

export default connect(
    (state, props) => ({
        owner: state.getIn(['participants', props.owner])
    })
)(Owner);
